import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import withRouter from "components/Common/withRouter";
import { jwtDecode } from "jwt-decode";

//i18n
import { withTranslation } from "react-i18next";
import SidebarContent from "./SidebarContent";
import SidebarUser from "./sidebarcontentuser";
import { Link } from "react-router-dom";

import logo from "../../assets/images/logo.svg";
import logoLightPng from "../../assets/images/logo-light.png";
import logoLightSvg from "../../assets/images/logo-light.png";
import logoDark from "../../assets/images/logo-dark.png";
import { getClinic, getClinicById, getImage, getUsers } from "service/api";
import { getalluser } from "service/myapi";

const Sidebar = props => {

  const [isAdmin, setIsAdmin] = useState(false);
  const [userId, setUserId] = useState(null);
  const [clinicID, setclinicID] = useState(null);
  const [Image, setLogoUrl] = useState(null);
  const [username, setusername] = useState(null);
  const [token, setToken] = useState(null);
  const [alluserlist, setallusers] = useState({ users: [] })

  // const dispatch = useDispatch();

  useEffect(() => {
    const getCookie = (name) => {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
    };

    const myrole = getCookie('userType');
    if (myrole === 'admin') {
      setIsAdmin(true);
    }

    const storedToken = localStorage.getItem('token');
    setToken(storedToken);
    // console.log('Token from LocalStorage:', storedToken);
    if (storedToken) {
      try {
        const decodedToken = jwtDecode(storedToken);
        setUserId(decodedToken.userId);
        // console.log('UserID from Token:', decodedToken.userId);
        setusername(decodedToken.username);
        // console.log('UserID from Token:', decodedToken.username);
        setclinicID(decodedToken.clinicID);
        // console.log('UserID from Token:', decodedToken.clinicID);
      } catch (error) {
        console.error('Failed to decode token:', error);
      }
    }
    fetchData();
  }, []);


  const fetchData = async () => {
    if (clinicID) {
      try {
        const response = await getClinicById(clinicID); // Fetch clinic data
        setallusers(response.data);

        if (response.data && response.data.name) {
          // console.log('Clinic Name:', response.data.logo);

          // Extract image name from the logo path
          const logoPath = response.data.logo;
          const imageName = logoPath.split('\\').pop();
          // console.log('Extracted Image Name:', imageName);

          const imageResponse = await getImage(imageName);
          if (imageResponse) {
            const imageUrl = URL.createObjectURL(imageResponse.data);
            setLogoUrl(imageUrl);
          }
        } else {
          console.log('Clinic data does not contain a name field');
        }
      } catch (error) {
        console.error('Failed to fetch clinic data:', error);
      }
    } else {
      console.error('No clinicID available to fetch data');
    }
  };

  useEffect(() => {
    fetchData();
  }, [clinicID]);





  return (
    <React.Fragment>
      <div className="vertical-menu">
        <div className="navbar-brand-box">
          <Link to="/" className="logo logo-dark">
            <span className="logo-sm">
              {Image ? (
                <img src={Image} alt="Logo" height="22" />
              ) : (
                <span className="fw-bold text-dark fs-5">Focus360</span>
              )}
            </span>

            <span className="logo-lg">
              {Image ? (
                <img src={Image} alt="Logo" height="50" />
              ) : (
                <span className="fw-bold text-dark fs-4">Focus360</span>
              )}
            </span>
          </Link>

          <Link to="/" className="logo logo-light">
            <span className="logo-sm">
              {Image ? (
                <img src={Image} alt="Logo" height="50" />
              ) : (
                <span className="fw-bold text-dark fs-5">Focus360</span>
              )}
            </span>

            <span className="logo-lg">
              {Image ? (
                <img src={Image} alt="Logo" height="50" />
              ) : (
                <span className="fw-bold text-dark fs-4">Focus360</span>
              )}
            </span>
          </Link>
        </div>

        <div data-simplebar className="h-100">
          {isAdmin ? (props.type !== "condensed" ? <SidebarContent /> : <SidebarContent />) : (props.type !== "condensed" ? <SidebarUser /> : <SidebarUser />)}
        </div>
        <div className="sidebar-background"></div>
      </div>
    </React.Fragment>
  );
};

Sidebar.propTypes = {
  type: PropTypes.string,
};

const mapStatetoProps = state => {
  return {
    layout: state.Layout,
  };
};
export default connect(
  mapStatetoProps,
  {}
)(withRouter(withTranslation()(Sidebar)));
